module.exports = __webpack_public_path__ + "img/moodboard-desktop.b1e9cf56.png";